import { AdminAssetTable } from 'features/adminAssetTable/AdminAssetTable';

export const AdminAssetListPage = (): JSX.Element => <AdminAssetTable />;
